module.exports = __webpack_public_path__ + "static/img/banner_2.deb6def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/banner_2.png
// module id = kin4
// module chunks = 1